module.exports = __webpack_public_path__ + "static/media/transactions.cccac329.svg";